import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { useMutation } from "react-query";
import { icCheck } from "../../../../components/image/image-src";
import { ModalBtn } from "../../../../components/modal/ModalBtn";
import { OkCancelPopup } from "../../../../components/modal/OkCancelPopup";
import { ProdAttrPicker } from "../../../../components/prodattr-picker/ProdAttrPicker";
import { ProductPopup } from "../../../../components/product-detail/ProductPopup";
import { useBookingState } from "../../../../hooks/useBookingState";
import { mappingBookingState2RequestDTO } from "../../../../mapping/mappingBookingState2RequestDTO";
import BookingService from "../../../../services/bookingService";
import {
  shouldSelectTimeLater,
  validateCalendar,
} from "../../../../utils/bookingUtils";
import { ProductModalIntroText } from "../../../Pass/components/SelectOptionSection/SelectProductModal";
import { useSelectTimeLaterModal } from "./useSelectTimeLaterModal";

interface Props {
  id: number;
  slug: string;
  isOpen?: boolean;
  onSubmit?: () => void;
  onClose?: () => void;
  product?: ProductDetailResponse;
  bookingId?: string;
}

const SelectTimeLaterModal: React.FC<Props> = ({
  id,
  slug,
  isOpen,
  onClose,
  onSubmit,
  bookingId,
}) => {
  const jj = useSelectTimeLaterModal({
    id,
    slug,
    isOpen,
    closeModal: onClose,
    bookingId,
  });
  const product = jj.product;
  const bookingState = useBookingState({
    mode: "POPUP",
  });
  const handleClose = () => {
    jj.bookingDispatch.bookingPickLs([]);
    jj.closeModal?.();
  };
  const { t } = useTranslation();
  const [success, setSuccess] = useState(false);
  const mutation = useMutation(
    async () => {
      return await BookingService.selectTimeLater({
        ...mappingBookingState2RequestDTO(bookingState),
        id: bookingId,
      });
    },
    {
      onSuccess: (data) => {
        setSuccess(true);
        // window.location.reload();
      },
      onError: (error: any) => {
        alert("Error: " + error.message);
      },
    },
  );

  const handleSubmit = () => {
    mutation.mutate();
  };

  const handleOk = () => {
    // setReceiveSuccess(false);
    onSubmit && onSubmit();
    onClose?.();
    window.location.reload();
  };

  const renderReceiveForm = () => {
    return (
      <ProductPopup product={product}>
        {/* Body */}
        <>
          <ProductModalIntroText product={product} showViewProduct={true} />
          <ProdAttrPicker calendarOnly={true} d={product} mode="POPUP" />
        </>
        {/* Footer */}
        <>
          <div className="flex justify-end gap-4 py-5">
            <ModalBtn opts={["cancel", "md"]} onClick={handleClose}>
              {t("Close")}
            </ModalBtn>
            <ModalBtn
              disabled={
                mutation.isLoading ||
                shouldSelectTimeLater(bookingState) ||
                !validateCalendar(bookingState.bookingAttributes)
              }
              onClick={handleSubmit}
              opts={["primary", "md", mutation.isLoading && "loading"]}
            >
              {t("Apply")}
            </ModalBtn>
          </div>
        </>
      </ProductPopup>
    );
  };

  const renderModal = () => {
    if (success) {
      return (
        <OkCancelPopup
          ic={icCheck}
          title={t("Success!")}
          onOk={() => handleOk()}
          onCancel={undefined}
          okText={t("Ok")}
        />
      );
    }
    return renderReceiveForm();
  };

  return <>{isOpen && renderModal()}</>;
};

export default SelectTimeLaterModal;
